module.exports = __webpack_public_path__ + "img/downloading-dark.1377a6a4.svg";